import { render, staticRenderFns } from "./SingleFaqPage.vue?vue&type=template&id=b4741dce&scoped=true&"
import script from "./SingleFaqPage.vue?vue&type=script&lang=js&"
export * from "./SingleFaqPage.vue?vue&type=script&lang=js&"
import style0 from "./SingleFaqPage.vue?vue&type=style&index=0&id=b4741dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4741dce",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/single_faq_page.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Ffaq%2FSingleFaqPage.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports